import Vue from 'vue'
import _ from 'underscore'
import axios from 'axios'
import appRouter from '@/router'
import { SERVICE_URL } from "../../_commons"
import getReCaptchaHeaderTBR from "@/utils/recaptchaTBR"

const namespaced = true;

const state = {
  customerName: '',
  dateOfBirth: '',
  lastFourDigitsOfSsn: '',
  licenseNumber: '',
  ddNumber: '',
  plateType: {},

  customerId: '',
  duration: 0,
  sessionStartDate: '',
  sessionEndDate: '',
  sessionUid: '',
  accessToken: '',
  vehicleRegistrationId: '',
  personalInformation: null,
  credentialInformation: null,
  blocksInformation: null,
  registrationInformation: null,
  adjudicationLicenseInformation: null,
  adjudicationCommercialLicenseInformation: null,
  adjudicationRegistrationInformation: null,
  renewRegistration: null,
  selectRenewRegistartion: null,
  reservationInformation: null,

  cartTransactions: '',
  extensionData: '',
  onlineTransactionFeeCollection: [],
  allFeesCollection: [],
  transactionCartId: '',

  renewalCart: [],

  totalBill: null,
  cartTotal : null,

  step: 1,

  duplicateReg: false,
  cancelReg: false,


  outputDocumentInformation: null,
  modalDocumentType: false,
  VehicleRegIdTxnId: [],

  // activeAlert: false
  crashLocation: {},
  mfaStep: 1,
  mfaType: null,
  btnDisable: false,

  contactUpdateStep: 1,

  updateContact: null,
  contactUpdateInfo: null,
  contactVerifyEmail: false,
  contactVerifyPhone: false,
  createContact: false,
  contactMfaRequest: [],

  addressUpdateStep: 1,

  userPhysicalAddress: [],
  userMailingAddress: [],
  standardPhysicalAddress: {},
  standardMailingAddress: {},
  skipStepTo: false
};

const mutations = {
  setState(state, data) {
    Vue.set(state, data.property, data.value);
  }
};
  
const actions = {
  /**
   * @param state
   * @param commit
   * @param rootState
   * @returns {Promise<void>}
   */

  async getGuestLoginRequest({ rootState, state, commit }) {
    const endpoint = `${SERVICE_URL}customeraccountlogin/guestloginrequest`;
    let dataObj = {};
    if(state.loginTypeId == 1) {
      dataObj = {
        loginLicense: {
          dateOfBirth: state.loginTypeId == 1 ? state.dateOfBirth : '',
          lastFourSssn: state.lastFourDigitsOfSsn, 
          lastname: state.loginTypeId == 1 ? state.customerName : '',
          licenseNumber: state.licenseNumber, 
        },
        loginTypeId: state.loginTypeId,
        loginAdjudication: null,
        loginCrash: null,
        loginVehicle: null
      }
    }
    if(state.loginTypeId == 2) {
      dataObj = {
        loginVehicle: {
          dateOfBirth: state.loginTypeId == 2 ? state.dateOfBirth : '',
          lastname: state.loginTypeId == 2 ? state.customerName : '',
          plateNumber: state.plateNumber,
          plateTypeId: state.plateType.code,
          vinLastSix: state.vinLastSix
        },
        loginTypeId: state.loginTypeId,
        loginAdjudication: null,
        loginCrash: null,
        loginLicense: null
      }
    }
    if(state.loginTypeId == 3) {
      dataObj = {
        loginAdjudication: {
          caseSummonTicketNumber: state.caseSummonTicketNumber,
          dateOfBirth: state.loginTypeId == 3 ? state.dateOfBirth : '',
          lastname: state.loginTypeId == 3 ? state.customerName : '',
          // suspensionEffectiveDate: state.suspensionEffectiveDate || '',
          // violationDate: state.violationDate || ''
        },
        loginTypeId: state.loginTypeId,
        loginVehicle: null,
        loginCrash: null,
        loginLicense: null
      }
      if(state.suspensionEffectiveDate != '' && state.suspensionEffectiveDate != null) {
        dataObj.loginAdjudication.suspensionEffectiveDate = state.suspensionEffectiveDate
      }
      if(state.violationDate != '' && state.violationDate != null) {
        dataObj.loginAdjudication.violationDate = state.violationDate
      }
    }
    if(state.loginTypeId == 4) {
      dataObj = {
        loginCrash: {
          crashDate: state.crashDate || '',
          crashLocationId: state.crashLocation.code,
          dateOfBirth: state.loginTypeId == 4 ? state.dateOfBirth : '',
          lastname: state.loginTypeId == 4 ? state.customerName : '',
        },
        loginTypeId: state.loginTypeId,
        loginVehicle: null,
        loginAdjudication: null,
        loginLicense: null
      }
    }

    const config = await getReCaptchaHeaderTBR('post', endpoint);
    axios.post(endpoint, dataObj, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        let data = result.data;
        commit('setState', { property: 'loginUserDetails', value: result.data });
        appRouter.push({ name: 'MultiFactAuth' });
        if(data.isPaperOtpSent) {
          commit('setState', { property: 'mfaStep', value: 2 });
          commit('setState', { property: 'mfaType', value: 3 });
        }
        else if(data.email=='' && data.phone=='') {
          commit('setState', { property: 'mfaStep', value: 3 });
        }
        else {
          commit('setState', { property: 'mfaStep', value: 1 });
        }
      }
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getGuestLoginMfaRequest({ rootState, state, commit }, data) {
    const endpoint = `${SERVICE_URL}customeraccountlogin/guestloginmfarequest`;
    const payload = {
      loginRequestToken: state.loginUserDetails.loginRequestToken,
      mfaType: data.mfaType,
      mfaTypeValue: data.mfaTypeValue
    }

    const config = await getReCaptchaHeaderTBR('post', endpoint);
    axios.post(endpoint, payload, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        if(data.mfaType == 4) {
          commit('setState', { property: 'mfaStep', value: 4 });
        }
        else if(data.mfaType == 3) {
          commit('setState', { property: 'mfaStep', value: 5 });
        }
        else {
          commit('setState', { property: 'loginMfaRequest', value: result.data });
          commit('setState', { property: 'mfaStep', value: 2 });
          commit('setState', { property: 'mfaType', value: data.mfaType });
        }
      }
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getGuestLogin({ rootState, state, commit }, data) {
    const endpoint = `${SERVICE_URL}customeraccountlogin/guestlogin`;
    const payload = {
      loginRequestToken: state.loginUserDetails.loginRequestToken,
      mfaType: state.mfaType,
      verificationCode: data.verificationCode
    }

    const config = await getReCaptchaHeaderTBR('post', endpoint);
    axios.post(endpoint, payload, config)
    .then(result => {
      // move on to profile screen IFF it's a 200
      if (result.status === rootState.STATUSES.SUCCESS) {
        commit('setState', { property: 'accessToken', value: result.data.accessToken });
        commit('setState', { property: 'duration', value: result.data.duration });
        if(state.loginUserDetails.isPaperOtpSent && state.mfaType == 3) {
          commit('setState', { property: 'contactUpdateStep', value: 1 });
          commit('setState', { property: 'createContact', value: true });
          appRouter.push({ name: 'UpdateContacts' });
        }
        else {
          appRouter.push({ name: 'Profile' });
        }
      }
    })
    .catch(error => {
      console.error(error);
      if(data.attemptValue == 3) {
        setTimeout(() => {
          appRouter.push({ name: 'GuestSignin' });
        }, 10000)
      }
    });
  },

  /**
   * @param context
   * @param data 
   * @returns {Promise<void>}
   */
  async setGuestLoginData(context, data) {
    const { runLookup, ...props } = data;
    // save module properties
    _.mapObject(props, (val, key) => {
      context.commit('setState', { property: key, value: val });
    });

    // do lookup?
    if (runLookup) {
      await context.dispatch('getGuestLoginRequest');
    }
  },


  async getGuestSendMfaRequest({ rootState, state, commit }, data) {
    const endpoint = `${SERVICE_URL}customeraccount/sendmfarequest`;
    const payload = {
      email: data.email,
      phone: data.phone
    }
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}`, payload, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        let contactData = {
          email: data.email !='',
          phone: data.phone !=''
        }
        if(!data.resendOtp) {
          commit('setState', { property: 'updateContact', value: contactData });
          commit('setState', { property: 'contactUpdateInfo', value: data });
          commit('setState', { property: 'contactUpdateStep', value: 3 });
          commit('setState', { property: 'contactMfaRequest', value: result.data });
          commit('setState', { property: 'contactVerifyEmail', value: false });
          commit('setState', { property: 'contactVerifyPhone', value: false });
        }
        // console.log('RESULT IS', result)

      }
    })
    .catch(error => {
      console.error(error);
    });
  },


  async getGuestVerifyMfa({ rootState, state, commit }, data) {
    const endpoint = `${SERVICE_URL}customeraccount/verifymfacode`;
    const payload = {
      mfaType: data.mfaType,
      verificationCode: data.verificationCode
    }
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);
    
    axios.post(`${endpoint}?accessToken=${token}`, payload, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) { 
        if(data.mfaType == 2) {
          commit('setState', { property: 'contactVerifyEmail', value: true });
        }
        if(data.mfaType == 1) {
          commit('setState', { property: 'contactVerifyPhone', value: true });
        }
          // appRouter.push({ name: 'Profile' })
      }
    })
    .catch(error => {
      console.error(error);
      if(data.attemptValue == 3) {
        commit('setState', { property: 'btnDisable', value: true });
        setTimeout(() => {
          appRouter.push({ name: 'GuestSignin' });
        }, 10000)
      }
    });
  },

  /**
 * @param state
 * @param commit
 * @param rootState
 * @returns {Promise<void>}
 */

  async getCreateTransactionService({state, commit, rootState }) { 
    let transactionTypeId = 197;
    if(state.duplicateReg) {
      transactionTypeId = 198;
    } else if(state.cancelReg) {
      transactionTypeId = 199;
    } else {
      transactionTypeId = 197;
    }
    const endpoint = `${SERVICE_URL}transactionservice`
    const data = {'transactionReasonId': 0, 'transactionTypeId':  transactionTypeId };
    const config = await getReCaptchaHeaderTBR('post', endpoint);

    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}`, data, config)
      // axios.post(endpoint, {params}, config, data)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        commit('setState', { property: 'cartTransactions', value: result.data });
        commit('setState', {property: 'step', value: 2});
        commit('setState', { property: 'onlineTransactionFeeCollection', value: null });
       
        state.VehicleRegIdTxnId.push({vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,transactionId: result.data.cartTransactions[0].transactionData.transactionId}) 
      }
    })
    .catch(error => {
      console.error(error);
    });

  },

  async getSaveWipData({state, rootState, dispatch, commit}) {

    let endpoint = `${SERVICE_URL}renewregistration/saveworkinprogressdata`
    if(state.duplicateReg) {
      endpoint = `${SERVICE_URL}duplicateregistration/saveworkinprogressdata`
    } else if(state.cancelReg) {
      endpoint = `${SERVICE_URL}cancelregistration/saveworkinprogressdata`
    } else {
      endpoint = `${SERVICE_URL}renewregistration/saveworkinprogressdata`
    }
    // const endpoint = state.duplicateReg ? `${SERVICE_URL}duplicateregistration/saveworkinprogressdata` :
    // state.cancelReg ? `${SERVICE_URL}cancelregistration/saveworkinprogressdata` :  `${SERVICE_URL}renewregistration/saveworkinprogressdata`

    const config = await getReCaptchaHeaderTBR('post', endpoint);
      
    let cartTxn = state.cartTransactions.cartTransactions[0];


    const headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json'
    }

    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}&vehicleRegistrationId=${state.selectRenewRegistartion.vehicleRegistrationId}&transactionId=${cartTxn.transactionData.transactionId}`, headers, config )
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        if(!state.cancelReg){
          dispatch('getRegistrationRenewalFee')
        } 
        else {
          commit('setState', {property: 'step', value: 3});
        } 
      }
    })
    .catch(error => {
      console.error(error);
    });

  },

  async getAddTransaction({state, rootState, commit }) {
    const endpoint = `${SERVICE_URL}transactionservice/addtransaction`
    const config = await getReCaptchaHeaderTBR('post', endpoint);

    let transactionTypeId = 197;
    if(state.duplicateReg) {
      transactionTypeId = 198;
    } else if(state.cancelReg) {
      transactionTypeId = 199;
    } else {
      transactionTypeId = 197;
    }

    let arrayCartTxns = [];
      for(let i=0; state.cartTransactions.cartTransactions.length > i; i++) {
        arrayCartTxns.push({
          transactionData: state.cartTransactions.cartTransactions[i].transactionData,
          transactionFees: state.renewalCart[i]?.onlineTransactionFeeCollection
        })
      }
    
    const data = { 
      transactionCart: {
        cartTransactions: arrayCartTxns,
        email: state.cartTransactions.email,
        isPaperlessCommunication: state.cartTransactions.isPaperlessCommunication,
        phone: state.cartTransactions.phone,
        transactionCartId: state.cartTransactions.transactionCartId, 
      },
      transactionRequest: {
        transactionReasonId: 0,
        // transactionTypeId: state.duplicateReg ? 198 : 197
        // transactionTypeId: state.duplicateReg ? 198 : state.cancelReg ? 199 : 197 
        transactionTypeId: transactionTypeId
      },
    };
    
    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}`, data, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) {
        commit('setState', { property: 'cartTransactions', value: result.data });
        commit('setState', {property: 'step', value: 2});
        commit('setState', { property: 'onlineTransactionFeeCollection', value: null });
       
        state.VehicleRegIdTxnId.push({vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,transactionId: result.data.cartTransactions[0].transactionData.transactionId})
      }
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getRemoveTransaction({state, rootState, commit}, data) {
    
      const endpoint = `${SERVICE_URL}transactionservice/removetransaction`;
      const config = await getReCaptchaHeaderTBR('post', endpoint);
      const token = encodeURIComponent(state.accessToken);
      commit('setState', { property: 'isLoading', value: true });
      let currentTxn = [];
      
      if (data != null) {
        currentTxn = state.cartTransactions.cartTransactions[data];
      } else {
        currentTxn = state.cartTransactions.cartTransactions[0];
      }

      let arrayCartTxns = [];
      for(let i=0; state.cartTransactions.cartTransactions.length > i; i++) {
        arrayCartTxns.push({
          transactionData: state.cartTransactions.cartTransactions[i].transactionData,
          transactionFees: state.cartTransactions.cartTransactions[i].transactionFees != null ? state.cartTransactions.cartTransactions[i].transactionFees : state.renewalCart[i]?.onlineTransactionFeeCollection
        })
      }
      const payload = { 
        transactionCart: {
          cartTransactions: arrayCartTxns,
          email: state.cartTransactions.email,
          isPaperlessCommunication: state.cartTransactions.isPaperlessCommunication,
          phone: state.cartTransactions.phone,
          transactionCartId: state.cartTransactions.transactionCartId, 
        },
        transactionData: currentTxn.transactionData
      };
      let result = undefined;
      try {
        result = await axios.post(`${endpoint}?accessToken=${token}`, payload, config);
        if (result.status === rootState.STATUSES.SUCCESS) {

          if (data != null) {
            state.renewalCart.splice(data, 1);
            state.cartTransactions.cartTransactions.splice(data, 1);
            // state.renewalCart.length == 0 ? appRouter.push({ name: 'Profile' }) : null;
            // state.renewalCart.length == 0 ? commit('setState', { property: 'step', value: 1 }) : null;
            if (state.renewalCart.length === 0) {
              appRouter.push({ name: 'Profile' });
            } 
            if(state.renewalCart.length === 0) {
              commit('setState', { property: 'step', value: 1 });
            } 
          } else {
            state.cartTransactions.cartTransactions.shift();
          }
        }
      } catch (error) {
        result = error.response;
      }
      return result;
  },

  async getCancelTransaction({state, rootState, commit}, data) {
    
    const endpoint = `${SERVICE_URL}transactionservice/removetransaction`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);

    let currentTxn = [];
    
    if (data != null) {
      currentTxn = state.cartTransactions.cartTransactions[data];
    } else {
      currentTxn = state.cartTransactions.cartTransactions[0];
    }

    let arrayCartTxns = [];
    for(let i=0; state.cartTransactions.cartTransactions.length > i; i++) {
      arrayCartTxns.push({
        transactionData: state.cartTransactions.cartTransactions[i].transactionData,
        transactionFees: state.cartTransactions.cartTransactions[i].transactionFees != null ? state.cartTransactions.cartTransactions[i].transactionFees : state.onlineTransactionFeeCollection
      })
    }
    const payload = { 
      transactionCart: {
        cartTransactions: arrayCartTxns,
        email: state.cartTransactions.email,
        isPaperlessCommunication: state.cartTransactions.isPaperlessCommunication,
        phone: state.cartTransactions.phone,
        transactionCartId: state.cartTransactions.transactionCartId, 
      },
      transactionData: currentTxn.transactionData
    };
    let result = undefined;
    try {
      result = await axios.post(`${endpoint}?accessToken=${token}`, payload, config);
      if (result.status === rootState.STATUSES.SUCCESS) {

        if (data != null) {
          state.renewalCart.splice(data, 1);
          state.cartTransactions.cartTransactions.splice(data, 1);
          // state.renewalCart.length == 0 ? appRouter.push({ name: 'Profile' }) : null;
          // state.renewalCart.length == 0 ? commit('setState', { property: 'step', value: 1 }) : null;
          if (state.renewalCart.length === 0) {
            appRouter.push({ name: 'Profile' });
          } 
          if(state.renewalCart.length === 0) {
            commit('setState', { property: 'step', value: 1 });
          } 
        } else {
          state.cartTransactions.cartTransactions.shift();
        }
      }
    } catch (error) {
      result = error.response;
    }
    return result;
  },

  async getRegistrationRenewalFee({ commit, state }) {
    const endpoint = state.duplicateReg ? `${SERVICE_URL}duplicateregistration/getduplicateregistrationfee` : `${SERVICE_URL}renewregistration/getregistrationrenewalfee`;
    
    const config = await getReCaptchaHeaderTBR('post', endpoint);

    const headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json'
    }

    let cartTxn = state.cartTransactions.cartTransactions[0];

    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}&vehicleRegistrationId=${state.selectRenewRegistartion.vehicleRegistrationId}&transactionId=${cartTxn.transactionData.transactionId}`, headers, config)
    .then(result => {
      commit('setState', { property: 'extensionData', value: result.data.extensionData });
      commit('setState', { property: 'onlineTransactionFeeCollection', value: result.data.onlineTransactionFeeCollection});
      commit('setState', {property: 'step', value: 3});
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getUpdateTransactionCart({ commit }) {
    commit('setState', {property: 'step', value: 4});
  },

  async getRenewPreviousStep({commit, state}) {
    let stepVal = state.step - 1;
    commit('setState', {property: 'step', value: stepVal});
  },

  async getServiceFees({ commit }, totalAmount) {
    const endpoint = `${SERVICE_URL}payment/getservicefees`;

    axios.get(`${endpoint}?totalFeeAmount=${totalAmount}`)
    .then(result => {
      commit('setState', { property: 'totalBill', value: result.data });
      commit('setState', {property: 'step', value: 5});
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getPaymentProcess(context, data) {
    const endpoint = `${SERVICE_URL}payment/process`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);

    let response = undefined;
    try {
      response = await axios.post(endpoint, data, config);
    } catch (error) {
      response = error.response;
    }
    return response;
  },

  async getFinalizecart({state, rootState, commit}, data) {
    const endpoint = `${SERVICE_URL}transactionservice/finalizecart`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);
    console.log('CONTEXT IS', rootState);
    
    let response = undefined;
    try {
      response = await axios.post(`${endpoint}?accessToken=${token}`, data, config);
      if (response.status === 200) {
        commit('setState', { property: 'finalizationCart', value: response.data });
      }
    } catch (error) {
      response = error.response;
    }
    return response;
  },

  async getSendTransactionConfiramtion({state, commit}, data) {
    const endpoint = `${SERVICE_URL}transactionservice/sendtransactionconfirmation`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);
    
    let response = undefined;
    try {
      response = await axios.post(`${endpoint}?accessToken=${token}`, data, config);
      if (response.status === 200) {
        commit('setState', {property: 'step', value: 6});
        commit('setState', {property: 'resNotificationSent', value: response.data});
      }
    } catch (error) {
      response = error.response;
    }
    return response;
  },

  async getPersonalProfileInformation({ commit, state }) {
    const endpoint = `${SERVICE_URL}customeraccount/personalprofileinformation`;
  
    const params = {
      accessToken: state.accessToken
    };
    axios.get(endpoint, {params})
    .then(result => {
      commit('setState', { property: 'personalInformation', value: result.data.onlineCustomerAccountPersonalInformation });
      commit('setState', { property: 'credentialInformation', value: result.data.onlineCustomerAccountCredentialInformation});
      commit('setState', { property: 'blocksInformation', value: result.data.onlineCustomerAccountBlocks});
      commit('setState', { property: 'reservationInformation', value: result.data.onlineCustomerPersonalReservations});
    })
    .catch(error => {
      // commit('setState', { property: 'personalInformation', value: null });
      // commit('setState', { property: 'credentialInformation', value: null});
      // commit('setState', { property: 'blocksInformation', value: null});
      console.error(error);
    });
  },

  async getRegistrationInformation({ commit, state }) {
    const endpoint = `${SERVICE_URL}customeraccount/registrationinformation`;
  
    const params = {
      accessToken: state.accessToken
    };
    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'registrationInformation', value: result.data.onlineRegistrationDetails });
    })
    .catch(error => {
      // commit('setState', { property: 'registrationInformation', value: null });
      console.error(error);
    });
  },


  async getRenewRegistrationEligibility({ commit, state }) {
    const endpoint = `${SERVICE_URL}renewregistration/transactioneligibility`;

    const params = {
      vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,
      accessToken: state.accessToken
    };

    // commit('setState', { property: 'activeAlert', value: false});
    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'renewRegistration', value: result.data });
      appRouter.push({path: '/renew-reg'});
      commit('setState', { property: 'duplicateReg', value: false });
      commit('setState', { property: 'cancelReg', value: false });
    })
    .catch(error => {
      // commit('setState', { property: 'activeAlert', value: true});
      console.error(error);
    });
  },

  async getDuplicateRegistrationEligibility({ commit, state }) {
    const endpoint = `${SERVICE_URL}duplicateregistration/transactioneligibility`;

    const params = {
      vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,
      accessToken: state.accessToken
    };

    // commit('setState', { property: 'activeAlert', value: false});
    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'duplicateRegistration', value: result.data });
      appRouter.push({path: '/duplicate-reg'});
      commit('setState', { property: 'duplicateReg', value: true });
      commit('setState', { property: 'cancelReg', value: false });
    })
    .catch(error => {
      // commit('setState', { property: 'activeAlert', value: true});
      console.error(error);
    });
  },

  async getCancelRegistrationEligibility({ commit, state }) {
    const endpoint = `${SERVICE_URL}cancelregistration/transactioneligibility`;

    const params = {
      vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,
      accessToken: state.accessToken
    };

    // commit('setState', { property: 'activeAlert', value: false});
    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'cancelRegistration', value: result.data });
      appRouter.push({path: '/cancel-reg'});
      commit('setState', { property: 'duplicateReg', value: false });
      commit('setState', { property: 'cancelReg', value: true });
    })
    .catch(error => {
      // commit('setState', { property: 'activeAlert', value: true});
      console.error(error);
    });
  }, 

  async getSelectRenewReg({ commit}, renewRegValue) {  
    commit('setState', { property: 'selectRenewRegistartion', value: renewRegValue });
  },


  async getAdjudicationInformation({ commit, state }) {
    const endpoint = `${SERVICE_URL}customeraccount/adjudicationinformation`;
  
    const params = {
      accessToken: state.accessToken
    };
    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'adjudicationLicenseInformation', value: result.data.baseLicensePrivilege });
      commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: result.data.commercialLicensePrivilege });
      commit('setState', { property: 'adjudicationRegistrationInformation', value: result.data.registrationPrivilege });
    })
    .catch(error => {
      // commit('setState', { property: 'adjudicationLicenseInformation', value: null });
      // commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: null });
      // commit('setState', { property: 'adjudicationRegistrationInformation', value: null });
      console.error(error);
    });
  },

  async getExtendGuestLogin({ state, commit, rootState }) {
    const endpoint = `${SERVICE_URL}customeraccountlogin/extendguestloginsession`;
    const params = {
      accessToken: state.accessToken
    };

    axios.get(endpoint, {params})
    .then(result => {
      // move on to signin screen IFF it's a 200
      if (result.status === rootState.STATUSES.SUCCESS) {
      commit('setState', { property: 'accessToken', value: result.data.accessToken });
      commit('setState', { property: 'duration', value: result.data.duration });
      }
      else
      {
         // move on to signin screen is extend session fails, extend session  may fail becuase of network errors
      
      appRouter.push({ path : '/guest-signin' });
      commit('setState', { property: 'guestLogin/statusInfo', value: null });
      commit('setState', { property: 'accessToken', value: null });
      commit('setState', { property: 'personalInformation', value: null });
      commit('setState', { property: 'credentialInformation', value: null });
      commit('setState', { property: 'registrationInformation', value: null });
      commit('setState', { property: 'adjudicationLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationRegistrationInformation', value: null });
      sessionStorage.removeItem('ridmv');
      window.location.href = '/guest-signin' ;
      }
    })
    .catch(error => {
      console.error(error);
      appRouter.push({ path : '/guest-signin' });
      commit('setState', { property: 'guestLogin/statusInfo', value: null });
      commit('setState', { property: 'accessToken', value: null });
      commit('setState', { property: 'personalInformation', value: null });
      commit('setState', { property: 'credentialInformation', value: null });
      commit('setState', { property: 'registrationInformation', value: null });
      commit('setState', { property: 'adjudicationLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationRegistrationInformation', value: null });
      sessionStorage.removeItem('ridmv');
      window.location.href = '/guest-signin' ;
    });
    
  },


  async getGuestLogout({ state, commit , rootState}) {
    const endpoint = `${SERVICE_URL}customeraccountlogin/guestlogout`;
    const params = {
      accessToken: state.accessToken
    };

    axios.get(endpoint, {params})
    .then(result => {
      
      // move on to signin screen IFF it's a 200
      if (result.status === rootState.STATUSES.SUCCESS) {
      
      appRouter.push({ path : '/guest-signin' });
      commit('setState', { property: 'guestLogin/statusInfo', value: null });
      commit('setState', { property: 'accessToken', value: null });
      commit('setState', { property: 'personalInformation', value: null });
      commit('setState', { property: 'credentialInformation', value: null });
      commit('setState', { property: 'registrationInformation', value: null });
      commit('setState', { property: 'adjudicationLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationRegistrationInformation', value: null });
      sessionStorage.removeItem('ridmv');
      window.location.href = '/guest-signin' ;
      }
    })
    .catch(error => {
      console.error(error);
      appRouter.push({ path : '/guest-signin' });
      commit('setState', { property: 'guestLogin/statusInfo', value: null });
      commit('setState', { property: 'accessToken', value: null });
      commit('setState', { property: 'personalInformation', value: null });
      commit('setState', { property: 'credentialInformation', value: null });
      commit('setState', { property: 'registrationInformation', value: null });
      commit('setState', { property: 'adjudicationLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationCommercialLicenseInformation', value: null });
      commit('setState', { property: 'adjudicationRegistrationInformation', value: null });
      sessionStorage.removeItem('ridmv');
      window.location.href = '/guest-signin' ;
    });
  },
  
  async getValidatecart({state, rootState, commit}, data) {
    const endpoint = `${SERVICE_URL}transactionservice/validatecart`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);
    console.log('CONTEXT IS', rootState);
    
    let response = undefined;
    try {
      response = await axios.post(`${endpoint}?accessToken=${token}`, data, config);
      if (response.status === 200) {
        commit('setState', { property: 'validatedcart', value: response.data });
      }
    } catch (error) {
      response = error.response;
    }
    return response;
  },

  async getOutputDocumentInformation({ commit, state }) {
    const endpoint = `${SERVICE_URL}duplicateregistration/getoutputdocument`;
    const params = {
      vehicleRegistrationId: state.selectRenewRegistartion.vehicleRegistrationId,
      accessToken: state.accessToken
    };

    axios.get(endpoint, {params})
    .then(result => { 
      commit('setState', { property: 'outputDocumentInformation', value: result.data });
      commit('setState', { property: 'modalDocumentType', value: true });
    })
    .catch(error => {
      console.error("getoutputdocument Error");
      console.error(error);
    });
  },

  /**
  * Gets Crash Location for UI drop down.
  * @returns {({cityId: string, description: string}|...)[]}
  */
  getCrashLocation({ commit }) {
    const endpoint = `${SERVICE_URL}customeraccountinboundreferencedata/getcrashlocation`

    axios.get(endpoint)
    .then(response => {
      commit('setState', { property: 'allCrashLocation', value: response.data });
    })
    .catch(error => {
      console.error(error);
    })
  },

  /**
  * Gets US States for UI drop down.
  * @returns {({stateId: string, description: string}|...)[]}
  */
  getUsStates({ commit }) {
    const endpoint = `${SERVICE_URL}customeraccountinboundreferencedata/getusstates`

    axios.get(endpoint)
    .then(response => {
      commit('setState', { property: 'allUsStates', value: response.data });
    })
    .catch(error => {
      console.error(error);
    })
  },


  /**
  * GetsZipCodes for UI drop down.
  * @returns {({zipId: string, description: string}|...)[]}
  */
  getInstateZipCodes({ commit }) {
    const endpoint = `${SERVICE_URL}customeraccountinboundreferencedata/getrizipcode`

    axios.get(endpoint)
    .then(response => {
      commit('setState', { property: 'allInstateZipcodes', value: response.data });
    })
    .catch(error => {
      console.error(error);
    })
  },
  
  getUpdateContact({commit}, data) {
    commit('setState', { property: 'updateContact', value: data });
    commit('setState', { property: 'contactUpdateStep', value: 2 });
  },

  async getUpdateAddress({ rootState, state, commit, dispatch}, data) {
    const endpoint = `${SERVICE_URL}customeraccount/validateaddress`;
    const payload = data;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}`, payload, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) { 
        if(data.addressCategoryId == 1) {
          commit('setState', { property: 'userPhysicalAddress', value: payload });
          commit('setState', { property: 'standardPhysicalAddress', value: result.data });
        }
        else {
          commit('setState', { property: 'userMailingAddress', value: payload });
          commit('setState', { property: 'standardMailingAddress', value: result.data });
          dispatch('getCheckAddressValidate');
        }
      }
    })
    .catch(error => {
      console.error(error);
    });
  },

  async getCheckAddressValidate({ state, commit}) {
    commit('setState', { property: 'physicalAddressMsg', value: '' });
    commit('setState', { property: 'mailingAddressMsg', value: '' });
    if (Object.keys(state.standardPhysicalAddress).length > 0 && Object.keys(state.standardMailingAddress).length > 0) {
      let standardPhysicalAddress = state.standardPhysicalAddress;
      let standardMailingAddress = state.standardMailingAddress;

      let physicalErrorCode = standardPhysicalAddress.individualAddressMelissaDataCollection[0].resultcodes;
      let physicalErrorMsg = standardPhysicalAddress.individualAddressMelissaDataCollection[0].message;
      let mailingErrorCode = standardMailingAddress.individualAddressMelissaDataCollection[0].resultcodes;
      let mailingErrorMsg = standardMailingAddress.individualAddressMelissaDataCollection[0].message;
      
      var physicalerrorarray = physicalErrorCode.match('AE') != null;
      if(!physicalerrorarray) {
        physicalerrorarray = physicalErrorCode.match('AS10') != null;
      }
      let mailingerrorarray = mailingErrorCode.match('AE') != null;

      if(physicalerrorarray) {
        commit('setState', { property: 'physicalAddressMsg', value: physicalErrorMsg });
      }
      if(mailingerrorarray) {
        commit('setState', { property: 'mailingAddressMsg', value: mailingErrorMsg });
      }
      if(!physicalerrorarray && !mailingerrorarray) {
        commit('setState', { property: 'addressUpdateStep', value: 2 });
      }
      window.scroll(0,0);
      document.body.setAttribute("tabindex", "1");
      document.body.focus();
  
      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
    }
  },

  async postConfirmAddress({ rootState, state}, data) {
    const endpoint = `${SERVICE_URL}customeraccount/updatecustomeraddress`;
    const payload = data;
    const config = await getReCaptchaHeaderTBR('post', endpoint);
    const token = encodeURIComponent(state.accessToken);

    axios.post(`${endpoint}?accessToken=${token}`, payload, config)
    .then(result => {
      if (result.status === rootState.STATUSES.SUCCESS) { 
        appRouter.push({ path : '/profile' });
      }
    })
    .catch(error => {
      console.error(error);
    });
  },
};

const getters = {
  lookupInfo: state => ({
    allCrashLocation: state.allCrashLocation,
  }),
  addressLookupInfo: state => ({
    allUsStates: state.allUsStates,
    allInstateZipcodes: state.allInstateZipcodes
  }),
  statusInfo: state => ({
    customerName: state.customerName,
    dateOfBirth: state.dateOfBirth,
    lastFourDigitsOfSsn: state.lastFourDigitsOfSsn,
    licenseNumber: state.licenseNumber,
    ddNumber: state.ddNumber,

    customerId: state.customerId,
    duration: state.duration,
    sessionStartDate: state.sessionStartDate,
    sessionEndDate: state.sessionEndDate,
    sessionUid: state.sessionUid,
    accessToken: state.accessToken,
    vehicleRegistrationId: state.vehicleRegistrationId,
    renewRegistration: state.renewRegistration,

    plateType: state.plateType,

  }),
  personalInfo: state => ({
    personalInformation: state.personalInformation,
    credentialInformation: state.credentialInformation,
    blocksInformation: state.blocksInformation,
    reservationInformation: state.reservationInformation
  }),
  registrationInfo: state => ({
    registrationInformation: state.registrationInformation,
  })
  ,
  outputDocumentInfo: state => ({
    outputDocumentInformation: state.outputDocumentInformation
  }) ,
  adjudicationLicenseInfo: state => ({
    adjudicationLicenseInformation: state.adjudicationLicenseInformation,
  })
  ,
  adjudicationCommercialLicenseInfo: state => ({
    adjudicationCommercialLicenseInformation: state.adjudicationCommercialLicenseInformation,
  })
    ,
  adjudicationRegistrationInfo: state => ({
    adjudicationRegistrationInformation: state.adjudicationRegistrationInformation,
  })
  ,
  transactionInfo: state => ({
    cartTransactions: state.cartTransactions,
    transactionReasonId: state.transactionReasonId,
    transactionTypeId: state.transactionTypeId,
    transactionCartId: state.transactionCartId
  })
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
}